'use client';
import type { LiaValuesType } from './data';

import React from 'react';
import Image from 'next/image';

import { Container, Grid, GridItem, Icon, Stack, Text } from '@/components';
import { useTranslation } from '@/hooks';
import Executive1 from '@/images/aboutUs/executive-1.jpg';
import Executive2 from '@/images/aboutUs/executive-2.jpg';
import Executive3 from '@/images/aboutUs/executive-3.png';
import Executive4 from '@/images/aboutUs/executive-4.jpg';
import DonateIcon from '@/svgs/aboutUs/values/Handshake.svg';
import LeafIcon from '@/svgs/aboutUs/values/Leaf.svg';
import LightBulbIcon from '@/svgs/aboutUs/values/Lightbulb.svg';
import StarIcon from '@/svgs/aboutUs/values/star.svg';
import UserIcon from '@/svgs/aboutUs/values/Users.svg';

const LiaValues: LiaValuesType = () => {
  const { t } = useTranslation('pages.aboutUs');

  const FEATURES = [
    {
      id: 1,
      title: t('valuesTitle.respect'),
      icon: DonateIcon as React.ElementType,
    },
    {
      id: 2,
      title: t('valuesTitle.customer'),
      icon: UserIcon as React.ElementType,
    },
    {
      id: 3,
      title: t('valuesTitle.quality'),
      icon: StarIcon as React.ElementType,
    },
    {
      id: 4,
      title: t('valuesTitle.innovation'),
      icon: LightBulbIcon as React.ElementType,
    },
    {
      id: 5,
      title: t('valuesTitle.simple'),
      icon: LeafIcon as React.ElementType,
    },
  ];

  const IMAGES = [
    { image: Executive3, gridArea: '1 / 7 / 7 / 12' },
    { image: Executive4, gridArea: '7 / 7 / 11 / 12' },
    { image: Executive1, gridArea: '1 / 1 / 6 / 7' },
    { image: Executive2, gridArea: '6 / 1 / 11 / 7' },
  ];

  return (
    <Container my={{ base: 16, md: 24 }}>
      <Stack
        justifyContent="center"
        flexDir={{ base: 'column', md: 'row' }}
        gap={12}
        px={{ base: 0, md: 8 }}
      >
        <Stack
          flexDir="column"
          alignItems={{ base: 'center', md: 'flex-start' }}
          gap={12}
          p={{ base: 0, md: 8 }}
        >
          <Stack w={{ base: '120px', md: '200px' }}>
            <Text
              fontSize={{ base: '2xl', md: '34px' }}
              w="max-content"
              fontWeight={500}
            >
              {t('liaValuesTitle')}
            </Text>
          </Stack>
          <Text
            textAlign={{ base: 'center', md: 'right' }}
            lineHeight={{ base: 2.5, md: 1.5 }}
          >
            {t('ourBackgroundDescription')}
          </Text>
          <Stack flexDir="row" gap={{ base: 10, md: 12 }}>
            {FEATURES.map((feature) => (
              <Stack key={feature.id} gap={4}>
                <Icon
                  as={feature.icon}
                  w={{ base: 10, md: 12 }}
                  h={{ base: 10, md: 12 }}
                />
                <Text fontWeight={700}>{feature.title}</Text>
              </Stack>
            ))}
          </Stack>
        </Stack>
        <Grid
          gridTemplateColumns="repeat(11, 1fr)"
          gridTemplateRows="repeat(10, 1fr)"
          gridColumnGap={2}
          gridRowGap={2}
        >
          {IMAGES.map((item, index) => (
            <GridItem key={index} gridArea={item.gridArea}>
              <Image
                src={item.image}
                alt="lia-team"
                width={300}
                height={300}
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  borderRadius: 18,
                }}
              />
            </GridItem>
          ))}
        </Grid>
      </Stack>
    </Container>
  );
};

export default LiaValues;
